import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import selfStyles from "../css/Fp.css";
import { request, origin } from "../request";
import { Header } from "./Introduce";
import { getId } from "./ReceivingInformation";
import { Button, Toast } from "antd-mobile";
import teststyles from "../css/test.css";
import uploadFile from "../tools/uploadFile";
import {
  checkPhone,
  checkNumOrEN,
  Loading,
  checkNum,
  checkChineseP,
  CheckSocialCreditCodeOrg,
  showAlert2,
} from "../tools/wechatBrower";
import _ from "lodash";

export default class extends React.Component {
  state = {
    model: "",
    data: {
      default: {},
      info: [],
    },
    type: "",
    uploaedImages: [],
    phone: "",
    company_id: "",
    loading: false,
  };

  componentDidMount() {
    this.init();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   // eslint-disable-next-line
  //   if (prevProps.match.params.model === this.props.match.params.model) {
  //     return true;
  //   } else {
  //     // eslint-disable-next-line
  //     this.state.model = this.props.match.params.model;
  //     this.init();
  //     return true;
  //   }
  // }
  componentDidUpdate(prevProps, prevState) {
    console.log(
      "prevProps.match.params.model === this.props.match.params.model",
      prevProps.match.params.model === this.props.match.params.model
    );
    // eslint-disable-next-line
    if (prevProps.match.params.model === this.props.match.params.model) {
      return false;
    } else {
      // eslint-disable-next-line
      this.state.model = this.props.match.params.model;
      this.init();
      return true;
    }
  }

  uploadImage(e) {
    this.setState({
      isuploading: true,
    });
    uploadFile(e, (res) => {
      this.setState({
        isuploading: false,
      });
      console.log(res);
      if (res.code === 0) {
        Toast.fail(res.msg);
      } else {
        let filename = res.data.url.split("_")[1];
        let each = {
          url: res.data.url,
          filename: filename,
        };
        this.state.uploaedImages.push(each);
        this.setState();
      }
    });
  }

  init() {
    switch (this.props.match.params.model) {
      case "add":
        this.setState({
          model: "",
          data: {
            default: {},
            info: [],
          },
          type: "普票",
          uploaedImages: [],
          phone: "",
          company_id: "",
        });
        break;
      case "list":
        request(
          "index/getInvoice",
          {
            // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
            uid: localStorage.getItem("openid"),
          },
          ({ data }) => {
            console.log(data, "12321");
            if (data.data.info) {
              this.setState({
                data: data.data,
              });
            }
          }
        );
        break;
      default:
        break;
    }

    this.setState({
      model: this.props.match.params.model,
    });
  }

  _add() {
    if (this.state.type === "普票") {
      if (
        !(this.state.company_name && this.state.company_id && this.state.type)
      ) {
        Toast.fail("必填项");
        return;
      }
    } else {
      if (
        !(
          this.state.company_name &&
          this.state.company_id &&
          this.state.type &&
          getId("address") &&
          this.state.phone &&
          getId("bank_deposit")
        )
      ) {
        Toast.fail("必填项");
        return;
      }
    }

    if (getId("address").length > 100) {
      Toast.fail("收件地址最多100个字符");
      return;
    }

    if (!checkChineseP(this.state.company_name)) {
      Toast.fail("开票单位必须是中文或者括号，最多五十个字符");
      return;
    }

    if (!CheckSocialCreditCodeOrg(this.state.company_id)) {
      Toast.fail("纳税识别号格式不对");
      return;
    }
    let attachfiles = "";

    if (this.state.uploaedImages) {
      attachfiles = this.state.uploaedImages
        .map((obj, index) => {
          return obj.url;
        })
        .join(",");
    }

    request(
      "index/createInvoice",
      {
        uid: localStorage.getItem("openid"),
        // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
        type: this.state.type,
        company_name: this.state.company_name,
        company_id: this.state.company_id,
        phone: this.state.phone,
        address: getId("address"),
        bank_deposit: getId("bank_deposit"),
        smallimages: attachfiles,
      },
      ({ data }) => {
        console.log(data);
        // eslint-disable-next-line
        if (data.code === 1) {
          // Toast.success("创建成功");
          setTimeout(() => {
            this.props.history.push("/fp/list");
          }, 1000);
        } else {
          Toast.fail("创建失败");
        }
      }
    );
  }

  sumbit() {
    if (this.state.model === "list") {
      return (
        <div
          style={{
            position: "fixed",
            height: "70px",
            left: 0,
            bottom: 0,
            right: 0,
            // backgroundColor: "rgb(51 51 51 / 14%)",
            display: "flex",
            maxWidth: "375px",
            margin: "auto",
          }}
        >
          <Button
            type="primary"
            style={{
              width: "88%",
              backgroundColor: "#AE5CC9",
              borderRadius: "23px",
              border: "1px solid #AE5CC9",
              margin: "auto",
            }}
            onClick={() => {
              if (this.state.data.info.length < 3) {
                this.setState({
                  model: "add",
                });
                this.props.history.push("/FPAdd");
              } else {
                Toast.info("最多创建3个");
              }
            }}
          >
            添加发票信息
          </Button>
        </div>
      );
    } else if (this.state.model === "add") {
      return (
        <div
          style={{
            position: "fixed",
            height: "70px",
            left: 0,
            bottom: 0,
            right: 0,
            backgroundColor: "rgb(51 51 51 / 14%)",
            display: "flex",
            maxWidth: "375px",
            margin: "auto",
          }}
        >
          <Button
            type="primary"
            style={{
              width: "88%",
              backgroundColor: "#AE5CC9",
              borderRadius: "23px",
              border: "1px solid #AE5CC9",
              margin: "auto",
            }}
            onClick={_.throttle(this._add.bind(this), 500)}
          >
            添加
          </Button>
        </div>
      );
    }
  }

  type(e) {
    // console.log(e.target.value);
    // this.state.type = ;

    this.setState({
      type: e.target.value,
    });
  }

  bank_deposit(e) {
    console.log(e, "~~~");
    this.state.data.name = e;
    this.setState({
      data: this.state.data,
    });
  }

  main() {
    switch (this.state.model) {
      case "add":
        return (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <div className={styles.info}>
                <div
                  style={{ display: "flex" }}
                  onChange={(e) => {
                    this.type(e);
                  }}
                >
                  <input type="radio" name="type" value="普票" defaultChecked />
                  <span className={selfStyles.pText}>普票</span>
                  <input type="radio" name="type" value="专票" />
                  <span className={selfStyles.pText}>专票</span>
                </div>

                <p className={selfStyles.text}>
                  备注：如果开专票请提供开票详细信息和单位营业执照扫描件
                </p>
              </div>

              <div className={styles.info}>
                <div className={styles.head}>
                  <span className={styles.title}>发票信息</span>
                </div>
                <Item
                  left="* 开票单位"
                  rightP="请输入开票单位"
                  // id="company_name"
                  value={this.state.company_name}
                  onChange={(e) => {
                    console.log(e,'E')
                    this.state.company_name = e;
                  }}
                  onBlur={(e) => {
                    let is_phone = checkChineseP(this.state.company_name);
                    if (!is_phone) {
                      Toast.fail("开票单位只允许中文，最多五十个字符");
                      return;
                    }
                  }}
                ></Item>
                <Item
                  left="* 纳税识别号"
                  rightP="请输入纳税识别号,请注意大写"
                  id="company_id"
                  value={this.state.company_id}
                  onChange={(e) => {
                    if (checkNumOrEN(e)) {
                      this.state.company_id = e;
                      this.setState();
                    }
                  }}
                  onBlur={(e) => {
                    let is_phone = CheckSocialCreditCodeOrg(
                      this.state.company_id
                    );
                    if (!is_phone) {
                      Toast.fail("纳税识别号格式不对");
                      return;
                    }
                  }}
                ></Item>
              </div>

              <div
                className={styles.info}
                style={{
                  display: this.state.type === "普票" && "none",
                }}
              >
                <div className={styles.head}>
                  <span className={styles.title}>专票必填</span>
                </div>
                <Item
                  left="* 地址"
                  rightP="请输入地址"
                  id="address"
                  onBlur={(e) => {
                    if (getId("address").length > 100) {
                      Toast.fail("地址最多100个字符");
                      return;
                    }
                  }}
                ></Item>
                <Item
                  left="* 电话"
                  rightP="请输入电话"
                  id="phone"
                  value={this.state.phone}
                  onChange={(e) => {
                    if (checkNum(e)) {
                      this.state.phone = e;
                      this.setState();
                    }
                  }}
                  onBlur={(e) => {
                    let is_phone = checkPhone(this.state.phone);
                    if (!is_phone) {
                      Toast.fail("手机号格式不正确");
                      return;
                    }
                  }}
                ></Item>
                <Item
                  left="* 开户行及账户"
                  rightP="请输入开户行及账户"
                  id="bank_deposit"
                ></Item>
                <div></div>
              </div>

              <div
                className={styles.info}
                style={{
                  display: this.state.type === "普票" && "none",
                }}
              >
                <div className={styles.head}>
                  <span className={styles.title}>上传附件</span>
                  <span className={styles.des}></span>
                </div>

                <div>
                  <p
                    style={{
                      marginTop: "0.3rem",
                      lineHeight: "1rem",
                      textAlign: "left",
                    }}
                  >
                    该处可通过手机上传拍照或者图片，可通过微信浏览器PC端上传WORD、PDF文件；
                  </p>
                  <p
                    style={{
                      marginTop: "0.3rem",
                      lineHeight: "1rem",
                      textAlign: "left",
                    }}
                  >
                    因存储空间有限请仅上传包含分析方法（颜色标记）的图片或文件，文件小于10M。
                  </p>
                </div>

                <div className={teststyles["upload-container"]}>
                  <input
                    type="file"
                    name="image"
                    className={teststyles["upload-input"]}
                    onChange={(e) => {
                      this.uploadImage(e.target.files[0]);
                    }}
                  />
                  <Button type="primary">上传文件</Button>
                </div>

                <div className={styles.chusedImage}>
                  {this.state.uploaedImages.map((item, index) => (
                    <div key={index} className={styles.photoWeaper}>
                      {",png,jpg,svg,jpeg,".indexOf(
                        "," + item.url.split(".")[1] + ","
                      ) !==-1 ? (
                        <div>
                          <img src={origin + item.url} alt="" />
                          <p
                            style={{
                              fontSize: "0.7rem",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "black",
                              top: "0",
                            }}
                          >
                            {item.filename}
                          </p>
                        </div>
                      ) : (
                        <img src={require("../static/文件.jpg")} alt="" />
                      )}
                      <p
                        onClick={() => {
                          console.log();
                          this.state.uploaedImages.splice(index, 1);
                          this.setState();
                        }}
                      >
                        删除
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );

      case "list":
        console.log("this.state.data", this.state.data);
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {this.state.data.info.map((element, index) => (
              <div className={styles.info}>
                <div className={styles.head}>
                  <span className={styles.title}>发票信息</span>
                </div>

                <Item
                  left="发票类型"
                  value={element.type}
                  disabled={true}
                ></Item>
                <Item
                  left="公司名称"
                  rightP="请输入公司名称"
                  value={element.company_name}
                  disabled={true}
                ></Item>
                <Item
                  left="税号"
                  rightP="请输入税号"
                  value={element.company_id}
                  disabled={true}
                ></Item>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderTop: "solid 1px #999999",
                    height: "25px",
                    alignItems: "flex-end",
                    marginTop: "10px",
                  }}
                >
                  {/* <div>
                    <input
                      type="radio"
                      name="moren"
                      value={element.id}
                      checked={
                        element.id === this.state.data.default.invoice_id
                      }
                      onChange={(e) => {
                        request(
                          "index/changeDefaultFp",
                          {
                            uid: localStorage.getItem("openid"),
                            // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
                            invoice_id: element.id,
                          },
                          ({ data }) => {
                            console.log(data);
                            if (data.code === 1) {
                              // Toast.info("成功");
                              // eslint-disable-next-line
                              // this.state.data.default.receiving_id = element.id;
                              this.setState({
                                data: this.state.data,
                              });
                            }
                          }
                        );
                      }}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        color: "rgb(174, 92, 201)",
                        marginRight: "5px",
                      }}
                    >
                      默认
                    </span>
                  </div> */}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "rgb(174, 92, 201)",
                    }}
                    onClick={() => {
                      this.props.history.push("/FpDetail/" + element.id);
                    }}
                  >
                    修改
                  </span>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "rgb(174, 92, 201)",
                    }}
                    onClick={() => {
                      showAlert2({
                        content: "删除后不可以修复，请问确认删除吗？",
                        cancelFunc: () => {},
                        enterFunc: () => {
                          let that = this;
                          that.setState({
                            loading: true,
                          });
                          request(
                            "index/deleteFp",
                            {
                              uid: localStorage.getItem("openid"),
                              id: element.id, // localStorage.getItem("openid"),
                            },
                            ({ data }) => {
                              that.setState({
                                loading: false,
                              });
                              if (data.code === 1) {
                                // Toast.info("成功");
                                delete that.state.data.info[index];
                                that.setState();
                                // eslint-disable-next-line
                                // this.state.data.default.receiving_id = element.id;
                              }
                            }
                          );
                        },
                      });
                    }}
                  >
                    删除
                  </span>
                </div>
              </div>
            ))}
            <div style={{ height: "70px", width: "100%" }}></div>
          </div>
        );

      default:
        return <div></div>;
    }
  }

  render() {
    return (
      <div>
        <Header text="发票信息"></Header>
        {this.main()}
        {this.sumbit()}
        <div style={{ height: "80px", width: "100%" }}></div>
        <Loading loading={this.state.loading}></Loading>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Fp.js